export const ductEntryTypesMixin = {
  data() {
    return {
      ductEntryTypes: []
    };
  },

  computed: {
    selectedMask() {
      return this.$store.getters.getSelectedMask;
    }
  },

  mounted() {
    // this.getDuctEntryTypes();
  },

  methods: {
    getDuctEntryTypes() {
      let options = this.$store.getters.getDuctTypeList;
      if (options.length > 0) {
        this.ductEntryTypes = options;
      } else {
        this.$store.dispatch("fetchDuctTypeList").then(list => {
          this.ductEntryTypes = list;
        });
      }
    },

    getDuctEntryType(ductEntryTypeID) {
      return this.ductEntryTypes.find(
        ductEntryType => ductEntryType.code === ductEntryTypeID
      );
    },

    gridUnitHasDuctEntry(gridUnit) {
      return this.getGridUnitDuctEntryIndex(gridUnit) !== -1;
    },

    getGridUnitDuctEntryIndex(gridUnit) {
      if (
        this.selectedMask &&
        this.selectedMask.duct_entries &&
        this.selectedMask.duct_entries.length > 0
      ) {
        return this.selectedMask.duct_entries.findIndex(
          ductEntry =>
            ductEntry.mde_top === gridUnit.columnIndex &&
            ductEntry.mde_left === gridUnit.rowIndex
        );
      } else return -1;
    }
  }
};



// WEBPACK FOOTER //
// ./src/mixins/forms/masks/ductEntryTypesMixin.js